import _ from 'lodash'
import { reducerWithInitialState } from 'typescript-fsa-reducers'
import { Trigger } from '../../types'
import * as actions from './actions'

export type State = { [id: number]: Trigger }

export const initialState: State = {}

export default reducerWithInitialState(initialState).case(
	actions.registerTriggers,
	(state, objects) => {
		return { ...state, ..._.keyBy(objects, 'id') }
	},
)
